<template>
  <div
    v-if="step > 0"
    class="relative z-10"
  >
    <div class="absolute h-4 right-0 left-0 bg-peach" />
    <div
      v-if="!incidentLoading"
      class="absolute h-4 left-0 bg-accent transition-all duration-500"
      :class="progressBarStyle"
    />
    <div
      v-if="!incidentLoading"
      class="flex justify-around absolute right-0 left-0 -top-[10px] text-tiny transition-all duration-500"
      :class="{
        '-mt-4 opacity-0': scrolled || (hasOptionalFields && step === 4) || (!hasOptionalFields && step === 3),
      }"
    >
      <div
        class="h-24 w-24 flex justify-center items-center rounded-full font-medium transition-all duration-200"
        :class="{
          'bg-accent text-white delay-[300ms]': step >= 1,
          'bg-peach text-primary-default': step < 1,
        }"
      >
        1
      </div>
      <div
        class="h-24 w-24 flex justify-center items-center rounded-full font-medium transition-all duration-200"
        :class="{
          'bg-accent text-white delay-[300ms]': step >= 2,
          'bg-peach text-primary-default': step < 2,
        }"
      >
        2
      </div>
      <div
        v-if="hasOptionalFields"
        class="h-24 w-24 flex justify-center items-center rounded-full font-medium transition-all duration-200"
        :class="{
          'bg-accent text-white delay-[300ms]': step >= 3,
          'bg-peach text-primary-default': step < 3,
        }"
      >
        3
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useIncidentStore } from '@/store/incident';
import { storeToRefs } from 'pinia';

const incidentStore = useIncidentStore();
const { incidentLoading, step } = storeToRefs(incidentStore);

const props = defineProps<{
  scrolled: boolean;
  hasOptionalFields: boolean;
}>();

const progressBarStyle = computed(() => {
  if (props.hasOptionalFields) {
    return {
      'right-[100%]': step.value === 0,
      'right-[83.4%]': step.value === 1,
      'right-[50%]': step.value === 2,
      'right-[16.6%]': step.value === 3,
      'right-[0%]': step.value === 4,
    };
  } else {
    return {
      'right-[100%]': step.value === 0,
      'right-[75%]': step.value === 1,
      'right-[25%]': step.value === 2,
      'right-[0%]': step.value === 3,
    };
  }
});
</script>
